import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { INVALID_LINKEDIN_URL } = ERROR_TYPE;

export const OnboardingSettingsSchema = z
	.object({
		companyWebsite: z.string().optional(),
		linkedinUrl: z.string().optional(),
		personalLinkedinUrl: z.string().optional(),
	})
	.superRefine(({ personalLinkedinUrl }, ctx) => {
		if (personalLinkedinUrl && !personalLinkedinUrl.includes("linkedin.com/in/")) {
			ctx.addIssue({
				code: "custom",
				path: ["personalLinkedinUrl"],
				message: INVALID_LINKEDIN_URL,
			});
		}
	});

export type OnboardingSettings = z.infer<typeof OnboardingSettingsSchema>;
